<div class="col-12">
  <ng-template [ngIf]="isLoad" [ngIfElse]="loading">
    <table class="table table-responsive d-none d-lg-block">

        <tbody style="    width: 100%;
        display: table;" >
            <tr class="" *ngFor="let book of displayBookList; index as i; first as isFirst " >
              <td   > {{book.station_name}}</td>
              <td  >{{getDateFormat(book.startdate)}}</td>
              <td  >{{getDateFormat(book.enddate)}}</td>
              <td >{{book.price}} €</td>
              <td  >
                <a *ngIf="book.type === 1 || book.type === 3 || book.type === 10 || book.type === 12" routerLink="/auth/reservation/{{book.id}}" >
                  <button  mat-stroked-button  class="titleBookk">{{ 'RESERVATION.BOUTONDETAIL' | translate }}</button>
                </a>
                <a *ngIf="book.type === 0 || book.type === 7" routerLink="/auth/reservation/{{book.id}}" >
                  <button  mat-stroked-button class="recharge-font">{{ 'RESERVATION.BOUTONDETAIL' | translate }}</button>
                </a>
                </td>
            </tr>
        </tbody>
      </table>
    <div class="row d-lg-none">
      <table class="col-12 table table-responsive">

        <tbody style="    width: 100%;
        display: table;" >
            <tr *ngFor="let book of displayBookList; index as i; first as isFirst " >
              <td   > {{book.station_name}}</td>
              <td  >
                <a routerLink="/auth/reservation/{{book.id}}" >
                  <button  mat-stroked-button >{{ 'RESERVATION.BOUTONDETAIL' | translate }}</button>
                </a>
                </td>
            </tr>
        </tbody>
      </table>
    </div>

      <!-- <table class="table table-sm col-12" >
          <tbody   class="row">
            <ng-template ngFor let-item [ngForOf]="bookList" let-i="book">
              <tr *ngFor="let book of bookList; index as i; first as isFirst"  style="width: 100%" class="row">
                <td style="font-size: 0.70em; " class="col-5" > {{book.station_name}}</td>
                <td style="font-size: 0.70em;" class="col-5" >
                  <a routerLink="/auth/reservation/{{book.id}}">
                    <button class="col-5" mat-stroked-button color="primary">Détail</button>
                  </a>
                  </td>
              </tr>
            </ng-template>
          </tbody>
        </table> -->

      <div class="col-12">
        <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          (page)="propertiesChange($event)">
        </mat-paginator>
      </div>
  </ng-template>
  <ng-template #loading>
    <div class="row">
      loading...
    </div>
  </ng-template>
</div>